import { useMemo } from "react";
import { useIntl } from "react-intl";
import messages from "./messages";

const useTranslations = () => {
  const { formatMessage } = useIntl();

  const result = useMemo(() => {
    const translations = {
      title: formatMessage(messages.title),
      btnAdd: formatMessage(messages.btnAdd),
      btnAdjust: formatMessage(messages.btnAdjust),
      totalPrice: formatMessage(messages.totalPrice),
      outstandingBalance: formatMessage(messages.outstandingBalance),
      refundDue: formatMessage(messages.refundDue),
      refunds: formatMessage(messages.refunds),
      btnViewReceipt: formatMessage(messages.btnViewReceipt),
      btnSendReceipt: formatMessage(messages.btnSendReceipt),
      couponTitle: formatMessage(messages.couponTitle),
    };

    return { translations };
  }, [formatMessage]);

  return result;
};

export default useTranslations;
